import { ActionReducerMap } from "@ngrx/store";
import { fetchUserProfileReducer } from "./fetch-userProfile.reducer";
import { fetchUserPendingRequestReducer } from "./fetch-pendingRequest.reducer";

export const UserProfileReducer: ActionReducerMap<any> = {
    FetchUserProfile:fetchUserProfileReducer,
    FetchPendingRequest:fetchUserPendingRequestReducer
};
